import { TwoFactorAppSetup } from "@/components/Portal/UserAccount/Security/Change/TwoFactorAppSetup";

export const TwoFactorSetupAppView = () => (
  <div className="max-w-[560px]">
    <TwoFactorAppSetup />
  </div>
);
